import { ViewModel, View } from "binder"
import { isUrlValid, stringIsNullOrEmpty, translate } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { UnitMultiSelectorViewModel } from "../../units/unitMultiSelector";
import { IProduct } from "../iProduct";
import { ProductEditorView } from "./productEditor-view"
import { ProductGroupSelectorViewModel } from "../../productGroup/productGroupSelector/productGroupSelector-viewModel";
import { ProductTypeSelectorViewModel } from "../productTypeSelector";
import { getAsNumber } from "src/uicomponents/components/utilities";

export class ProductEditorViewModel extends ViewModel implements IProduct {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._updater = updater;
        this.unitSelector = new UnitMultiSelectorViewModel(this);
        this.productGroupSelector = new ProductGroupSelectorViewModel(this);
        this.productGroupSelector.onSelectionChanged = selectedGroup => {
            if(this.canEdit){
                this.code = selectedGroup.prefixPath + selectedGroup.nextProductCodeSuffix;
            }
        }
        this.productTypeSelector = new ProductTypeSelectorViewModel(this);
        this.productTypeSelector.onSelectionChanged = selectedType => {
            if (selectedType == null || selectedType?.id != '2') {
                this.isRawMaterial = false;
                return;
            }
            this.isRawMaterial = true;
        }
        this.canEdit = true;
    }
    GetDefaultView(): View<ViewModel> {
        return new ProductEditorView();
    }
    public getTypeId(): string {
        return "VM-45EF169A-3C4D-4FBC-A9B1-4DA3F7818D45"
    }

    cloneTo(product: IProduct) {
        product.id = this.id;
        product.name = this.name;
        product.code = this.code;
        product.imageUrl = this.imageUrl;
        product.hasImage = this.hasImage;
        product.length = this.length;
        product.width = this.width;
        product.height = this.height;
        product.weight = this.weight;
        product.secondWeight = this.secondWeight;
        product.technicalNumber = this.technicalNumber;
        product.isSafetyMaterial = this.isSafetyMaterial;
        product.canEdit = this.canEdit;
        product.setUnitIds(this.getUnitIds());
        product.setProductGroupId(this.productGroupSelector.selectedGroup?.id);
        product.setProductTypeId(this.productTypeSelector.selectedItem?.id);
    }

    closePopup(result: any) {
    }

    private _updater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set secondaryCode(v: string) { this._secondaryCode = v; } public get secondaryCode(): string { return this._secondaryCode; } private _secondaryCode: string;
    public set typeName(v: string) { this._typeName = v; } public get typeName(): string { return this._typeName; } private _typeName: string;
    public set unitSelector(v: UnitMultiSelectorViewModel) { this._unitSelector = v; } public get unitSelector(): UnitMultiSelectorViewModel { return this._unitSelector; } private _unitSelector: UnitMultiSelectorViewModel;
    public set productGroupSelector(v: ProductGroupSelectorViewModel) { this._productGroupSelector = v; } public get productGroupSelector(): ProductGroupSelectorViewModel { return this._productGroupSelector; } private _productGroupSelector: ProductGroupSelectorViewModel;
    public set productTypeSelector(v: ProductTypeSelectorViewModel) { this._productTypeSelector = v; } public get productTypeSelector(): ProductTypeSelectorViewModel { return this._productTypeSelector; } private _productTypeSelector: ProductTypeSelectorViewModel;
    public set imageUrl(v: string) { this._imageUrl = v; } public get imageUrl(): string { return this._imageUrl; } private _imageUrl: string;
    public set hasImage(v: boolean) { this._hasImage = v; } public get hasImage(): boolean { return this._hasImage; } private _hasImage: boolean;
    public set columnDefinition(v: string) { this._columnDefinition = v; } public get columnDefinition(): string { return this._columnDefinition; } private _columnDefinition: string;
    public set length(v: number) { this._length = v; } public get length(): number { return this._length; } private _length: number;
    public set width(v: number) { this._width = v; } public get width(): number { return this._width; } private _width: number;
    public set height(v: number) { this._height = v; } public get height(): number { return this._height; } private _height: number;
    public set weight(v: number) { this._weight = v; } public get weight(): number { return this._weight; } private _weight: number;
    public set secondWeight(v: number) { this._secondWeight = v; } public get secondWeight(): number { return this._secondWeight;} private _secondWeight: number;
    public set technicalNumber(v: string) { this._technicalNumber = v; } public get technicalNumber(): string { return this._technicalNumber;} private _technicalNumber: string;
    public set isSafetyMaterial(v: boolean) { this._isSafetyMaterial = v; } public get isSafetyMaterial(): boolean { return this._isSafetyMaterial; } private _isSafetyMaterial: boolean;
    public set isRawMaterial(v: boolean) { this._isRawMaterial = v; } public get isRawMaterial(): boolean { return this._isRawMaterial; } private _isRawMaterial: boolean;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit; } private _canEdit: boolean;

    setProductGroupId(id: string) {
        this.productGroupSelector.selectById(id);
    }
    getProductGroupId(): string {
        return this.productGroupSelector.selectedGroup?.id;
    }

    setProductTypeId(id: string) {
        this.productTypeSelector.selectById(id);
    }

    getProductTypeId(): string {
        return this.productTypeSelector.selectedItem?.id;
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), translate("productEditor-viewModel.registrationError", {}));
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._updater.execute(this);
                await this.messageBoxConfirmSuccess(translate("productEditor-viewModel.successfullyRegistered", {}), translate("productEditor-viewModel.successfulRegistration", {}));
                this.closePopup(this);
            } catch (ex) {
                console.log("FaultId : " + ex);
                if (ex === '096473E7-67AE-4206-9B61-79B70943684A') {
                    await this.messageBoxConfirmWarning(`محصول با کد ${this.code} قبلا در سیستم ثبت شده است.`, 'خطا در ثبت');
                } else {
                    await this.messageBoxConfirmWarning(translate("productEditor-viewModel.registrationError", {}), translate("productEditor-viewModel.operationErorr", {}));
                }
            } finally {
                this.isLoading = false;
            }
        }
    }
    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.name)) {
            result.push(translate("productEditor-viewModel.productNameError", {}));
        }if (stringIsNullOrEmpty(this.code)) {
            result.push(translate("productEditor-viewModel.productCodeError", {}));
        }if (this.unitSelector.selectedItems.length == 0) {
            result.push(translate("productEditor-viewModel.unitError", {}));
        }if (stringIsNullOrEmpty(this.imageUrl) == false && isUrlValid(this.imageUrl) == false) {
            result.push(translate("productEditor-viewModel.notValidUrl", {}));
        }if (this.productTypeSelector.selectedItem == null) {
            result.push(translate("productEditor-viewModel.typeError", {}));
        }if(this.productGroupSelector.selectedGroup == null){
            result.push("لطفا گروه کالا را انتخاب کنید.");
        }
        return result;
    }

    setUnitIds(value: string[]) {
        this.unitSelector.selectById(value);
    }
    getUnitIds(): string[] {
        return this.unitSelector.selectedItems.map(x => x.id);
    }

}

export interface IServerUpdater {
    execute(product: IProduct): Promise<any>;
}


export class ProductInserter implements IServerUpdater {
    async execute(product: IProduct): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/SimpleProductManipulationServices/CreateNewSimpleProduct', {
                Name: product.name,
                Code: product.code,
                SecondaryCode: product.secondaryCode,
                ImageUrl: product.imageUrl,
                Units: product.getUnitIds(),
                GroupId: product.getProductGroupId(),
                ProductTypeId: getAsNumber(product.getProductTypeId()),
                Height: product.height,
                Width: product.width,
                Weight: product.weight,
                SecondWeight: product.secondWeight,
                TechnicalNumber: product.technicalNumber,
                Length: product.length,
                IsSafetyMaterial: product.isSafetyMaterial
            });
            if (result.IsSuccessful == false) {
                throw result.Faults[0].Parameters.FaultId;
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}

export class ProductUpdater implements IServerUpdater {
    async execute(product: IProduct): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/SimpleProductManipulationServices/UpdateSimpleProduct', {
                Id: product.id,
                Units: product.getUnitIds(),
                Name: product.name,
                Code: product.code,
                SecondaryCode: product.secondaryCode,
                ImageUrl: product.imageUrl,
                GroupId: product.getProductGroupId(),
                ProductTypeId: getAsNumber(product.getProductTypeId()),
                Height: product.height,
                Width: product.width,
                Weight: product.weight,
                SecondWeight: product.secondWeight,
                TechnicalNumber: product.technicalNumber,
                Length: product.length,
                IsSafetyMaterial: product.isSafetyMaterial
            });
            if (result.IsSuccessful == false) {
                throw "Error Saving Product";
            }
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}


